<div class="progress-wrapper">
  <!-- Adds a mask around container and progress bar to ensure a curve is seen when low percentage -->
  <div class="progress-wrapper__progress-mask-out">
    <div class="progress-wrapper__progress-mask-in"></div>
  </div>

  <div data-display="progress-container" class="progress-wrapper__progress-container {{ customProgressClass }}">
    <div
      data-display="progress-bar"
      [style.width]="progressPercentageString"
      class="progress-wrapper__progress-bar"
      [style.background-color]="customBGColor"
      #progressBar
    >
      @if (customText) {
        <span class="progress-wrapper__custom-text" [style.color]="customTextColor">{{ customText }}</span>
      } @else {
        <div class="progress-wrapper__percent-wrapper" #percentWrapper>
          @if (showPercentInBar) {
            <div [style.color]="customTextColor">
              <span>{{ displayPercent ? progressPercentageString : progressValue }}</span>
            </div>
          } @else {
            <div class="progress-wrapper__value-in-bar color-grey">
              <span>{{ displayPercent ? progressPercentageString : progressValue }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
